/* eslint-disable  @typescript-eslint/no-explicit-any, camelcase */
/* Generated types. Do not edit by hand */
import * as Types from 'src/graphql.generated'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

const defaultOptions = {} as const
export type AdvancedMembershipReviewPatientFragment = {
  __typename?: 'Patient'
  uid: string
  firstname?: string | null
  lastname?: string | null
  careTeam?: Array<{ __typename?: 'CareTeamMember'; coachID: string; isPrimary: boolean }> | null
}

export type SearchAdvancedMembershipReviewPatientsQueryVariables = Types.Exact<{
  tagID: Types.Scalars['ID']['input']
  page: Types.Scalars['Int']['input']
}>

export type SearchAdvancedMembershipReviewPatientsQuery = {
  __typename?: 'Query'
  searchPatientsV2: {
    __typename?: 'SearchPatientsResponse'
    patientCount: number
    patients: Array<{
      __typename?: 'Patient'
      uid: string
      firstname?: string | null
      lastname?: string | null
      careTeam?: Array<{ __typename?: 'CareTeamMember'; coachID: string; isPrimary: boolean }> | null
    }>
  }
}

export type GetAdvancedMembershipReviewPatientsQueryVariables = Types.Exact<{
  uids: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']
}>

export type GetAdvancedMembershipReviewPatientsQuery = {
  __typename?: 'Query'
  patients: Array<{
    __typename?: 'Patient'
    uid: string
    firstname?: string | null
    lastname?: string | null
    careTeam?: Array<{ __typename?: 'CareTeamMember'; coachID: string; isPrimary: boolean }> | null
  }>
}

export const AdvancedMembershipReviewPatientFragmentDoc = gql`
  fragment AdvancedMembershipReviewPatient on Patient {
    uid
    firstname
    lastname
    careTeam {
      coachID
      isPrimary
    }
  }
`
export const SearchAdvancedMembershipReviewPatientsDocument = gql`
  query searchAdvancedMembershipReviewPatients($tagID: ID!, $page: Int!) {
    searchPatientsV2(
      tagIDs: [$tagID]
      includeOnlyPrimaryPatients: false
      page: $page
      pageSize: 499
      sortBy: LAST_NAME
      sortOrder: ASC
    ) {
      patients {
        ...AdvancedMembershipReviewPatient
      }
      patientCount
    }
  }
  ${AdvancedMembershipReviewPatientFragmentDoc}
`

/**
 * __useSearchAdvancedMembershipReviewPatientsQuery__
 *
 * To run a query within a React component, call `useSearchAdvancedMembershipReviewPatientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAdvancedMembershipReviewPatientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAdvancedMembershipReviewPatientsQuery({
 *   variables: {
 *      tagID: // value for 'tagID'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useSearchAdvancedMembershipReviewPatientsQuery(
  baseOptions: Apollo.QueryHookOptions<
    SearchAdvancedMembershipReviewPatientsQuery,
    SearchAdvancedMembershipReviewPatientsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    SearchAdvancedMembershipReviewPatientsQuery,
    SearchAdvancedMembershipReviewPatientsQueryVariables
  >(SearchAdvancedMembershipReviewPatientsDocument, options)
}
export function useSearchAdvancedMembershipReviewPatientsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SearchAdvancedMembershipReviewPatientsQuery,
    SearchAdvancedMembershipReviewPatientsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    SearchAdvancedMembershipReviewPatientsQuery,
    SearchAdvancedMembershipReviewPatientsQueryVariables
  >(SearchAdvancedMembershipReviewPatientsDocument, options)
}
export type SearchAdvancedMembershipReviewPatientsQueryHookResult = ReturnType<
  typeof useSearchAdvancedMembershipReviewPatientsQuery
>
export type SearchAdvancedMembershipReviewPatientsLazyQueryHookResult = ReturnType<
  typeof useSearchAdvancedMembershipReviewPatientsLazyQuery
>
export type SearchAdvancedMembershipReviewPatientsQueryResult = Apollo.QueryResult<
  SearchAdvancedMembershipReviewPatientsQuery,
  SearchAdvancedMembershipReviewPatientsQueryVariables
>
export const GetAdvancedMembershipReviewPatientsDocument = gql`
  query getAdvancedMembershipReviewPatients($uids: [ID!]!) {
    patients(uids: $uids) {
      ...AdvancedMembershipReviewPatient
    }
  }
  ${AdvancedMembershipReviewPatientFragmentDoc}
`

/**
 * __useGetAdvancedMembershipReviewPatientsQuery__
 *
 * To run a query within a React component, call `useGetAdvancedMembershipReviewPatientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdvancedMembershipReviewPatientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdvancedMembershipReviewPatientsQuery({
 *   variables: {
 *      uids: // value for 'uids'
 *   },
 * });
 */
export function useGetAdvancedMembershipReviewPatientsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAdvancedMembershipReviewPatientsQuery,
    GetAdvancedMembershipReviewPatientsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetAdvancedMembershipReviewPatientsQuery, GetAdvancedMembershipReviewPatientsQueryVariables>(
    GetAdvancedMembershipReviewPatientsDocument,
    options
  )
}
export function useGetAdvancedMembershipReviewPatientsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAdvancedMembershipReviewPatientsQuery,
    GetAdvancedMembershipReviewPatientsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetAdvancedMembershipReviewPatientsQuery,
    GetAdvancedMembershipReviewPatientsQueryVariables
  >(GetAdvancedMembershipReviewPatientsDocument, options)
}
export type GetAdvancedMembershipReviewPatientsQueryHookResult = ReturnType<
  typeof useGetAdvancedMembershipReviewPatientsQuery
>
export type GetAdvancedMembershipReviewPatientsLazyQueryHookResult = ReturnType<
  typeof useGetAdvancedMembershipReviewPatientsLazyQuery
>
export type GetAdvancedMembershipReviewPatientsQueryResult = Apollo.QueryResult<
  GetAdvancedMembershipReviewPatientsQuery,
  GetAdvancedMembershipReviewPatientsQueryVariables
>
